export default "__VITE_ASSET__f366756f__"